<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: no handler; the bare .stop modifier only keeps the row click from firing when toggling the checkbox -->
<!-- biome-ignore-all lint/a11y/useKeyWithClickEvents: no action is triggered, so there is nothing to bind to a key -->
<script setup lang="ts">
  import { Checkbox } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { selectionCheckboxClass } from './InternalDataTable.css';

  defineProps<{ checked: boolean }>();

  const emits = defineEmits<{ change: [] }>();

  const { t } = useLocale('table');
</script>

<template>
  <div :class="['internal-checkbox', selectionCheckboxClass]" @click.stop>
    <Checkbox
      :model-value="checked"
      :aria-label="t('table.select_row')"
      @update:model-value="emits('change')"
    />
  </div>
</template>
